import axios from "axios";

export const fetchLoanApplications = async (params) => {
  return axios.get(`/partner/api/v1/loan-applications`, { params });
};
